module.exports = __webpack_public_path__ + "static/img/title.340d569.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/tideng/anniversary/title.png
// module id = t8KV
// module chunks = 4